
<div class="main-container">
    <b>Restaurant offering page</b> / info about the advantadges / etc. 
</div>

<!-- Footer -->
<landing-footer></landing-footer>